import React, { useState } from "react"
import { Roles } from "app/models/user"
import Box from "@material-ui/core/Box"
import SupportSettingsTogglerButton from "./SupportSettingsTogglerButton"
import SupportSettingsModal from "./SupportSettingsModal"

function SupportSettingsToggler() {
  const [showModal, setShowModal] = useState<boolean>(false)
  const toggleSupportSettingsModal = () => setShowModal(!showModal)
  return (
    <>
      <Box>
        <SupportSettingsTogglerButton allowedRoles={[Roles.Support]} onClick={toggleSupportSettingsModal} />
      </Box>
      {showModal && <SupportSettingsModal onClose={toggleSupportSettingsModal} />}
    </>
  )
}

export default SupportSettingsToggler
